import React from 'react'
import PropTypes from 'prop-types'
import merge from 'lodash/merge'
import Standard from './Standard'

class Float extends React.Component {
  static propTypes = {
    validations: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  }

  static defaultProps = {
    validations: {},
  }

  render = () => {
    const { validations, value, ...other } = this.props

    return (
      <Standard
        type='number'
        alignRight
        value={value || '0'}
        validations={merge({}, validations, { isFloat: true })}
        {...other}
      />
    )
  }
}

export default Float
